<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z9lA9y/tc-custom/9781526731302.jpg?1705001649290" alt="This image is the cover for the book Henry VIII in 100 Objects"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Henry VIII in 100 Objects
      </h1>
      <p class="bookDescription body article font2">
        <b>“Full of excellent and pristine photographs of many items and places that shaped the life of one of England’s most fascinating kings . . . five stars.” —UK Historian</b><br/><br/>Henry VIII is one of history’s most memorable monarchs. Popularly known for his six wives, and the unfortunate fate which befell Anne Boleyn and Catherine Howard, Henry initiated many reforms and changes which still affect our lives today.<br/><br/>In this engaging and hugely informative book, the author takes us on a journey across England, from Deal Castle on the south coast, to Tower Green where Anne Boleyn and Catherine Howard lost their heads, and far north to Rievaulx Abbey in Yorkshire. Along the way we see places where Henry stayed, where the Mary Rose, one of his great warships, was recovered, the homes of his consorts, and Smithfield where prominent individuals convicted of heresy were burned at the stake. Travel, then, not just across the country, but also back in time through 100 objects from the days of the second Tudor monarch—Henry VIII.<br/><br/><b>“Because the items and places are so varied, the book has a wealth of information and the author has done a lot of research to present as much detail as possible . . . [a] really well-written and illustrated book about the people, places and objects that would have been familiar to Henry VIII.” —Tudor Blogger</b><br/><br/><b>“Beautifully and profusely illustrated throughout . . . an extraordinarily informative and inherently fascinating introduction to the life and times of Henry VIII.” —Midwest Book Review</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Kendall
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?873fac46